import { Component, input } from "@angular/core";
import { OverviewPanelModel } from "./model/overview-panel-model";
import { RouterLink } from "@angular/router";
import { NgClass } from "@angular/common";

@Component({
  selector: "portal-overview-panel",
  templateUrl: "./overview-panel.component.html",
  standalone: true,
  imports: [RouterLink, NgClass],
  styleUrls: ["./overview-panel.component.scss"],
})
export class OverviewPanelComponent {
  readonly model = input<OverviewPanelModel | undefined>();
}
